import { Injectable } from "@angular/core";
import { BeaconRegionsHandlerService } from "../handlers/beacon-regions-handler.service";
import { BeaconRegionDTO } from "./BeaconRegion";

@Injectable({
  providedIn: "root",
})
export class BeaconRegionsService {
  constructor(
    private BeaconRegionsHandlerService: BeaconRegionsHandlerService,
  ) {}

  //LIST
  getBeaconRegions(
    masterAccountID: number,
    queryParams?: { facility_id?: number[]; page?: number; perPage?: number },
  ) {
    return this.BeaconRegionsHandlerService.getBeaconRegions(
      masterAccountID,
      queryParams,
    );
  }

  getBeaconRegion(masterAccountID: number, beaconRegionID: number) {
    return this.BeaconRegionsHandlerService.getBeaconRegion(
      masterAccountID,
      beaconRegionID,
    );
  }

  deleteBeaconRegion(accountMasterID: number, beaconRegionID: number) {
    return this.BeaconRegionsHandlerService.deleteBeaconRegion(
      accountMasterID,
      beaconRegionID,
    );
  }

  createBeaconRegion(
    accountMasterID: number,
    beaconRegionDTO: BeaconRegionDTO,
  ) {
    const copy = { ...beaconRegionDTO };
    return this.BeaconRegionsHandlerService.postBeaconRegion(
      accountMasterID,
      copy,
    );
  }

  updateBeaconRegion(
    accountMasterID: number,
    beaconRegionDTO: BeaconRegionDTO,
  ) {
    const copy = { ...beaconRegionDTO };
    return this.BeaconRegionsHandlerService.putBeaconRegion(
      accountMasterID,
      copy,
    );
  }
}
